const PRODUCTION_API = 'https://api-gzap.gtech.site/';
const LOCAL_API = 'http://localhost:3100/';

const endpoints = [
    {
        origin: 'localhost',
        endpoint: LOCAL_API
    },
    {
        origin: '127.0.0.1',
        endpoint: LOCAL_API
    },
    {
        origin: '192.168.0.100',
        endpoint: 'https://api-gzap-teste.gtech.site/'
    },
    {
        origin: '192.168.0.151',
        endpoint: 'https://api-gzap-teste.gtech.site/'
    },
    {
        origin: '192.168.88.68',
        endpoint: 'https://api-gzap-teste.gtech.site/'
    },
    {
        origin: 'gzap-teste.gtech.site',
        endpoint: 'https://api-gzap-teste.gtech.site/'
    },
    {
        origin: 'gzap.gtech.site',
        endpoint: 'https://api-gzap.gtech.site/'
    }
]

const getApiUrl = () => {
    try {
        if (typeof window === 'undefined') return PRODUCTION_API;
        const href = window.location?.href || '';
        const found = endpoints.find(e => href.includes(e.origin));
        return found ? found.endpoint : PRODUCTION_API;
    } catch (e) {
        return PRODUCTION_API;
    }
};

const getEnvLabel = () => {
    try {
        if (typeof window === 'undefined') return 'prod';
        const href = window.location?.href || '';
        if (href.includes('localhost') || href.includes('127.0.0.1')) return 'dev';
        if (href.includes('gzap-teste')) return 'teste';
        return 'prod';
    } catch {
        return 'prod';
    }
};

const config = {
    versao_gzap: '4.1.0',
    API_URL: getApiUrl(),
    ENV: getEnvLabel(),
    IS_DEV: getEnvLabel() === 'dev',
    IS_PROD: getEnvLabel() === 'prod',
}

export default config
